export default __webpack_public_path__ + "images/6bb003e12195deac6d3711bb9a2c4abb.png";